export const DEFAULT_BRAND = {
  allowCreateAccount: true,
  allowForgotPassword: true,
  hideCopyright: false,
  privacyUrl: 'https://support.hp.com/us-en/document/ish_12775809-12775790-16',
  termsUrl: 'https://www.hp.com/us-en/privacy/privacy-central.html',
  loginLogoUrl: 'dist/images/WorkforceExperienceLogo_light.svg',
  loginDarkLogoUrl: 'dist/images/WorkforceExperienceLogo_dark.svg',
  loginLogoAlt: 'Workforce Experience Collaboration',
  navLogo: 'dist/images/WorkforceExperienceLogo_light.svg',
  navLogoDark: 'dist/images/WorkforceExperienceLogo_dark.svg',
  supportUrl: undefined,
  supportContactUrl: undefined,
};

// this is just here for reference - we pass this in as env vars in the container deployment
export const ATT_BRAND = {
  allowCreateAccount: false,
  allowForgotPassword: false,
  hideCopyright: true,
  privacyUrl: '',
  termsUrl: '',
  loginLogoUrl: 'dist/images/att-logo-blk-type.png',
  loginLogoAlt: 'att',
  navLogo: 'dist/images/att_logo_medium_white.png',
  navLogoShield: 'dist/images/att_logo_shield.png',
  supportUrl: '',
};
